import { endpoints, request } from '!core/api';

export const userInstrumentsServices = {
  userInstruments: () => request.get(endpoints.chnn('wsbGetUserInstruments')),
  setUserFavoriteInstrument: ({
    option,
    instrument,
    symbol,
    exchange,
    securityType,
  }) =>
    request.put(
      endpoints.chnn(
        `wsbSetUserFavoriteInstrument?option=${option}&instrument=${instrument}&symbol=${symbol}&exchange=${exchange}&securityType=${securityType}`,
      ),
    ),
};
